import React from 'react'
import './Today.min.css'
const Sun = props => {

    const {sunrise, sunset}  = props.weather
    let sunriseTime = new Date(sunrise * 1000).getHours();
    let actualHour = new Date().getHours();
    let differentHour = actualHour - sunriseTime;
  
    let sunriseTime2 = new Date(sunrise*1000);
    let sunsetTime2 = new Date(sunset*1000);
    let differentTime = new Date(sunsetTime2.getTime() - sunriseTime2.getTime());
    let lenghtDay = (differentTime.getHours()) - 1;
   
   
    let number = Math.round(((differentHour * 100) / lenghtDay) / 10);
    
    
    if(number > 10 || number < 1){
        number = 0
    }
    let sunClass = "st" + number
    
   
    let a = document.getElementById("sun");
    a.setAttribute("class", sunClass)
    let stop = document.getElementById("stop")
    let number2 = "0." + number;
    if (number == 10){
        number2 = 1;
    } else if (number > 10){
        number2 = 0;
    }
  
    stop.setAttribute("offset",  number2)
    
    return(
        <div></div>
    )
}

export default Sun;